import React from 'react'
import injectSheet from 'react-jss'
import styles from './check-inbox-message.styles'
import Description from '../description/description'
import PobbleLink from 'pobble-components/dist/pobble-link'

const CheckInboxMessage = ({ classes }) => (
  <Description last title="Nearly there…">
    <p>
      We’ve sent you a confirmation email.
      <br />
      Please click the link in the email to activate your Pobble account.
    </p>
    <p className={classes.hint}>
      You should receive the link within 2 minutes.
      <br />
      If you haven’t received it, please check your spam folder, or email{' '}
      <PobbleLink href="mailto:hello@pobble.com?subject=Activation link not received">
        hello@pobble.com
      </PobbleLink>
    </p>
  </Description>
)

export default injectSheet(styles)(CheckInboxMessage)
